import type { TranslationTag } from '@ps/web-core-intl';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import EditIcon from '@swf/core/assets/icons/edit.svg';

import { container, summaryContent, summaryTitle, summaryWrapper } from './SummaryBox.scss';

interface Props {
  title: TranslationTag;
  details?: string;
  onClick?(): void;
}

const SummaryBox: React.FC<Props> = ({ title, details, onClick }) => (
  <div className={container} onClick={onClick}>
    <div className={summaryWrapper}>
      <span className={summaryTitle}>
        <Translation {...title} />
      </span>
      <div className={summaryContent}>{details}</div>
    </div>
    <EditIcon />
  </div>
);

export default SummaryBox;
